// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { FaWhatsapp } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-col">
          <h3>CustomSoft Solutions</h3>
          <p>
            Desarrollo de software a medida para empresas. Sistemas web, moviles e integraciones.
          </p>
        </div>

        <div className="footer-col">
          <h4>Enlaces</h4>
          <a href="/">Inicio</a>
          <a href="#servicios-section">Servicios</a>
          <a href="#contact-section">Contacto</a>
        </div>

        <div className="footer-col">
          <h4>Contacto</h4>
          <p>Entre Rios, Argentina</p>
          <p>
            <a href="mailto:contacto@customsoft-solutions.com.ar" className="footer-link">
              contacto@customsoft-solutions.com.ar
            </a>
          </p>
          <div className="footer-whatsapp">
            <a href="https://wa.me/543436114146" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp className="whatsapp-icon" /> +54 343 6114146
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} CustomSoft Solutions · Todos los derechos reservados
      </div>
    </footer>
  );
}

export default Footer;
